module.exports = __webpack_public_path__ + "img/application_trafo.b00eaa0d.webp";